"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

// const CMD_RESIZE = 's'
// const CMD_CROP = 'c'
var IMPRESSLY_BASE_URL = 'impress.ly';
var MYWEBSITEBUILDER_BASE_URL = 'images.builderservices.io';
var MYWEBSITEBUILDER_BASE_URL_LATEST = 'images-latest.builderservices.io';
var UNSPLASH_DOMAIN = 'images.unsplash.com'; // Refactor Remove the Impressly Image proxy

var ImageProxyHelper = /*#__PURE__*/function () {
  function ImageProxyHelper(src, cdnType) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ImageProxyHelper);

    this._proxyHash = function (value) {
      if (typeof value !== 'string' || value === '') {
        return 0;
      }

      value = value.toLowerCase();
      var c = 0;

      for (var i = 0; i < value.length; i++) {
        c ^= value.charCodeAt(i);
      }

      return c % 10;
    };

    this.crop = function (crop, originalSize) {
      if (_this.useUnsplash) {
        // resize to a bigger image ()
        if (crop.imageSize.width && crop.imageSize.height) {
          _this.src = _this.modifiyUnsplashUrl(_this.src, crop.imageSize.width, crop.imageSize.height);
        }

        _this.useUnsplash = false; // crop at our own server
      }

      var _crop$rect = crop.rect,
          x = _crop$rect.x,
          y = _crop$rect.y,
          width = _crop$rect.width,
          height = _crop$rect.height;

      var toPercentage = function toPercentage(val) {
        return Math.abs((val * 100).toFixed(4));
      }; // from normal to percentage with 4 decimals


      if (height > 0 && width > 0) {
        // con't be able to crop when height or width is zero
        _this.proxyModifiers.push("crop,".concat(toPercentage(x), "%,").concat(toPercentage(y), "%,").concat(toPercentage(width), "%,").concat(toPercentage(height), "%"));
      }

      return _this;
    };

    this.convertToType = function (type) {
      if (type) {
        _this.proxyModifiers.push("convert,".concat(type));
      }
    };

    this.resizeToWidth = function (width) {
      if (_this.useUnsplash) {
        _this.src = _this.modifiyUnsplashUrl(_this.src, width);
      } else {
        _this.proxyModifiers.push("resize,".concat(parseInt(width), ",5000"));
      }

      return _this;
    };

    this.result = function () {
      var baseUrl;

      if (_this.cdnType === 'cloudflareHosted') {
        baseUrl = '/s/cdn';
      } else {
        baseUrl = "https://".concat(ImageProxyHelper.getBaseUrl(), "/s/cdn");
      } // TODO: Fix better (EWE-2391)


      if (_this.src.indexOf('undefined') === 0) {
        _this.src = _this.src.substring(9);
      }

      var url = "".concat(baseUrl, "/v1.0/i/m?url=").concat(encodeURIComponent(_this.src));

      if (_this.proxyModifiers.length > 0) {
        var methods = _this.proxyModifiers.join('|');

        url += "&methods=".concat(encodeURIComponent(methods));
      }

      return url;
    };

    this.src = ImageProxyHelper.stripProxyUrl(src);
    var unsplashDomainIndex = src.indexOf(UNSPLASH_DOMAIN);
    this.useUnsplash = unsplashDomainIndex < 10 && unsplashDomainIndex >= 0;
    this.cdnType = cdnType;
    this.proxyModifiers = [];
    return this;
  }

  (0, _createClass2["default"])(ImageProxyHelper, [{
    key: "calcCropRect",
    value: function calcCropRect(rect, size) {
      return [Math.round(rect.x * size.width), Math.round(rect.y * size.height), Math.round(rect.width * size.width), Math.round(rect.height * size.height)];
    }
  }, {
    key: "modifiyUnsplashUrl",
    value: function modifiyUnsplashUrl(url, width, height, cropRect) {
      if (!this.useUnsplash) {
        throw Error('no Unsplash image');
      }

      var params = (0, _urlHelper.getQueryParametersFromUrl)(url);
      var split = url.split('?');
      params.w = parseInt(width);
      return "".concat(split[0], "?").concat((0, _urlHelper.param)(params));
    }
  }, {
    key: "forceIntoAspectRatio",
    value: function forceIntoAspectRatio(aspectRatio) {
      this.proxyModifiers.push("crop,".concat(aspectRatio));
      return this;
    }
  }, {
    key: "addColorOverlay",
    value: function addColorOverlay(colorOverlay, overlayOpacity) {
      this.proxyModifiers.push("overlay,".concat(colorOverlay.join(','), ",").concat(overlayOpacity, "%"));
      return this;
    }
  }], [{
    key: "getProxyUrl",
    value:
    /**
     * Will change the provided source URL and will return it prefixed with the Image Proxy Url.
     * @param {string} source, the image that should be routed through the image proxy.
     */
    function getProxyUrl(source) {
      return (0, _urlHelper.getUrl)(_urlHelper.siteNames.IMAGE_PROXY, source);
    }
  }, {
    key: "stripProxyUrl",
    value:
    /**
     * Used to extract the true image URL when the helper is used on image proxy URLs.
     * @param {string} src URL to extract the original URL from
     */
    function stripProxyUrl(src) {
      // Published sites
      if (src.startsWith('/s/cdn')) {
        var publishedMatch = src.match(/\/s\/cdn\/.*\?(?:url=)?([^&]+)/);

        if (publishedMatch && publishedMatch[1]) {
          return decodeURIComponent(publishedMatch[1]);
        }
      }

      var regex = /\/\/(.+)\/s\/cdn\/.*\?(?:url=)?([^&]+)/;
      var match = src.match(regex);

      if (!match || match[1] !== ImageProxyHelper.getBaseUrl() && match[1] !== IMPRESSLY_BASE_URL) {
        return src;
      }

      return decodeURIComponent(match[2]);
    }
  }]);
  return ImageProxyHelper;
}();

ImageProxyHelper.getBaseUrl = function () {
  var env = (0, _runtimeConfigHelper.getRuntimeConfig)()._env;

  return !env || env === 'prod' || env === 'uat' ? MYWEBSITEBUILDER_BASE_URL : MYWEBSITEBUILDER_BASE_URL_LATEST;
};

ImageProxyHelper.isProxiedUrl = function (src) {
  var result = false;
  [MYWEBSITEBUILDER_BASE_URL, MYWEBSITEBUILDER_BASE_URL_LATEST].forEach(function (proxyUrl) {
    if (src.includes(proxyUrl)) {
      result = true;
    }
  });
  return result;
};

ImageProxyHelper.getCountdownUrl = function (time, primaryColor, fontColor, backgroundColor, fonts, style) {
  return "https://".concat(ImageProxyHelper.getBaseUrl(), "/s/nocdn/v1.0/i/countdown?time=").concat(time, "&primaryColor=").concat(primaryColor, "&fontColor=").concat(fontColor, "&backgroundcolor=").concat(backgroundColor, "&font=").concat(fonts, "&style=").concat(style);
};

var _default = ImageProxyHelper;
exports["default"] = _default;